import { useSelector } from 'react-redux'
import { getSelectedMutationsSelector } from '../selectors'

export function useSelectedMutations() {
  return useSelector(getSelectedMutationsSelector)
}
